// @flow

export default {
  wizard: {
    next: 'Verder',
    back: 'Terug',
    skip: 'Overslaan',
    sort: 'Soort',
    sorting: {
      'utility:desc': 'Beste resultaat',
      'price:asc': 'Prijs stijgen',
      'price:desc': 'Prijzen dalen',
      'created_at:desc': 'Nieuwste',
      'customer_rating:desc': 'Klantbeoordeling'
    },
    clickToAddFiles: 'Klik om uw bestanden toe te voegen of laat ze hier vallen.',
    searchFor: 'Zoeken ...',
    noSearchResults: 'Helaas hebben we geen geschikte opties gevonden. Zoek opnieuw.',
    loadMoreAnswerOptions: 'Geen geschikte optie hier? Alle opties weergeven.',
    noRecommendationDescription: 'Oh nee, helaas konden we geen producten vinden die aan uw behoeften voldoen.',
    noRecommendationDescription2: 'Start de productadviseur opnieuw op.',
    noRecommendationRestartButtonTitle: 'Herstarten',
    noRecommendationCloseButtonTitle: 'Dichtbij',
    removeFile: 'Bestand verwijderen'
  },
  chatbot: {
    selectAll: 'Selecteer alles',
    none: 'Geen van hen',
    confirmButton: 'Versturen',
    customerServiceInputPlaceholder: 'Schrijf een bericht ...',
    you: 'Jij',
    restart: 'Begin opnieuw',
    close: 'Dichtbij',
    send: 'Versturen',
    supportChat: 'Ondersteuningschat',
    honeypot: 'Laat dit veld leeg',
    scrollToTheLatestMessage: 'Scroll naar het laatste bericht',
    removeFile: 'Bestand verwijderen'
  },
  product: {
    loadMore: 'Laad meer producten',
    badgeTitle: 'Onze aanbeveling',
    ctaButtonTitle: 'Meer details',
    matchingPanelTitle: 'Passend bij u',
    bestFit: 'Het beste bij',
    bestPrice: 'Beste prijs',
    bestFitForPrice: 'Beste prijs-kwaliteitverhouding',
    addToCartError: 'Toevoegen aan kar was niet succesvol. Probeer het opnieuw',
    addRoutineToCart: 'In winkelmandje',
    explanationHeader: 'Meer productinformatie:',
    emptyRoutineItem: 'Helaas is er geen product in die categorie die overeenkomt met uw voorkeuren.'
  },
  tabBar: {
    chat: 'Chat',
    productAdvisor: 'Productadviseur'
  },
  recommender: {
    answerOptionLeadsToNoRecommendation: 'Helaas zou deze optie niet tot een gewenst product leiden. U kunt uw voorkeur in eerdere stappen wijzigen om de optie in te schakelen.'
  }
}
